module.exports = __webpack_public_path__ + "overview-a5b6df21/map-182581ae9d90faf203884430c3a2fac2.svg";